import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { FaBars as HamburgerIcon } from 'react-icons/fa';
import classnames from 'classnames';

class DropdownMenu extends PureComponent {
  static propTypes = {
    trigger: PropTypes.element,
    children: PropTypes.node,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    openOnHover: PropTypes.bool,
    hideOnClick: PropTypes.bool,
  };

  static defaultProps = {
    children: [],
    hideOnClick: false,
  };

  hideDropDown = () => {
    this.dropdownRef.hide();
  };

  showDropDown = () => {
    this.dropdownRef.show();
  };

  render() {
    const {
      trigger,
      children,
      className,
      contentClassName,
      onShow,
      onHide,
      openOnHover,
      hideOnClick,
    } = this.props;

    return (
      <Dropdown
        className={className}
        ref={dropdown => this.dropdownRef = dropdown}
        onShow={onShow}
        onHide={onHide}
        onClick={hideOnClick ? this.hideDropDown : null}
        onMouseEnter={openOnHover ? this.showDropDown : null}
        onMouseLeave={openOnHover ? this.hideDropDown : null}
        disabled={openOnHover}
      >
        <DropdownTrigger className="hamburger-container">
          { trigger || <HamburgerIcon size={24} className="hamburger-icon"/> }
        </DropdownTrigger>
        <DropdownContent>
          <ul className={classnames('sub-navbar', contentClassName)}>
            {React.Children.map(children, item => {
              if (item) {
                const {
                  children: linkChildren,
                  className: linkClassName,
                  listElementClassName,
                  ...propsToPass
                } = item.props;

                return (
                  <li className={classnames('sub-nav-item', listElementClassName)}>
                    <item.type
                      {...propsToPass}
                      className={classnames(linkClassName, 'sub-nav-link')}
                    >
                      {linkChildren}
                    </item.type>
                  </li>
                );
              }
            })}
          </ul>
        </DropdownContent>
      </Dropdown>
    );
  }
}

export default DropdownMenu;
